const translations = {
  "en": {
    "Member already exists.": "Member already exists.",
    "No product ID found.": "No product ID found.",
    "Payment is only available in App environment.": "Payment is only available in App environment.",
    "Purchase failed.": "Purchase failed.",
    "This product is not available for in-app purchase.": "This product is not available for in-app purchase.",
    "Your device/OS doesn't support in-app purchases. Please upgrade your system or update Google Play and try again.": "Your device/OS doesn't support in-app purchases. Please upgrade your system or update Google Play and try again."
  },
  "zh-tw": {
    "Member already exists.": "成員已存在。",
    "No product ID found.": "找不到產品 ID。",
    "Payment is only available in App environment.": "付款僅可在應用程式環境中進行。",
    "Purchase failed.": "購買失敗。",
    "This product is not available for in-app purchase.": "此產品無法透過應用程式內購買。",
    "Your device/OS doesn't support in-app purchases. Please upgrade your system or update Google Play and try again.": "你的裝置/作業系統不支援應用程式內購買。請升級系統或更新 Google Play 後再試一次。"
  }
};

export default translations;
